<template>
  <span>{{ellipsis}}</span>
</template>

<script>
  export default {
    name: 'animated-ellipsis',
    data () {
      return {
        ellipsis: '',
        intervalID: null
      }
    },
    mounted () {
      this.intervalID = setInterval(() => { this.changeEllipsis() }, 500)
    },
    beforeDestroy () {
      clearInterval(this.intervalID)
    },
    methods: {
      changeEllipsis () {
        this.ellipsis = Array((this.ellipsis.length + 1) % 4 + 1).join('.')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/common/AnimatedEllipsis.vue